var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 0.416992H1.24996C0.789543 0.416992 0.416626 0.789909 0.416626 1.25033V11.2503C0.416626 11.7107 0.789543 12.0837 1.24996 12.0837H3.74996V15.8337C3.74996 15.9899 3.83704 16.1328 3.97579 16.2045C4.11246 16.2745 4.28038 16.2649 4.40871 16.1728L10.1333 12.0837H15.4166C15.877 12.0837 16.25 11.7107 16.25 11.2503V1.25033C16.25 0.789909 15.877 0.416992 15.4166 0.416992Z",
    fill: "#505F7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3.75H17.0833V11.6667C17.0833 12.3571 16.5237 12.9167 15.8333 12.9167H10.4004L6.90039 15.4167H10.7071L15.6021 18.68C15.7312 18.7658 15.8958 18.7725 16.0296 18.7008C16.1654 18.6283 16.25 18.4871 16.25 18.3333V15.4167H18.75C19.2104 15.4167 19.5833 15.0437 19.5833 14.5833V4.58333C19.5833 4.12292 19.2104 3.75 18.75 3.75Z",
    fill: "#505F7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.71528bda.svg";
export { ForwardRef as ReactComponent };